import { Constants, LOB, PopulationType } from '../common/Constants';
import { ConstantsLagoon } from '../common/ConstantsLagoon';
import { CoverageType } from '../common/PSXHeader/ObapiDemo/memberProfile';
import { getMemberHasDesignatedNetwork } from './user.utils';

export const filterVirtualCareEligibilitiesForDVCN = (memberInfo) => {
  if (!memberInfo) {
    return [];
  }

  let virtualCareEligibilities = memberInfo?.virtualCareEligibilities ?? [];
  const isENIMember = memberInfo?.lineOfBusiness === LOB.ENI;

  if (isENIMember) {
    let isNotDVCN = false;

    const coverageType: CoverageType | undefined =
      memberInfo.eligibility?.memberHealthCoverage?.coverageType?.find(
        (x: CoverageType) =>
          x?.typeCode &&
          x?.typeCode?.desc === Constants.COVERAGE_TYPECODE_TO_CHIP.M
      );

    if (coverageType && coverageType?.designatedNetwork) {
      isNotDVCN = !getMemberHasDesignatedNetwork(coverageType, 'DVCN');
    }

    if (isNotDVCN) {
      virtualCareEligibilities = virtualCareEligibilities.filter(
        (eligibility) => eligibility?.serviceType !== 'urgentCare'
      );
    }
  }

  return virtualCareEligibilities;
};

export const isVirtualCareSuppressed = (
  population = PopulationType.UNKNOWN
): boolean => {
  const suppressedPopulations: PopulationType[] = [
    ConstantsLagoon.CONFIG
      .SUPPRESSED_POPULATION_FOR_VIRTUAL_CARE as PopulationType,
  ];
  return suppressedPopulations?.includes(population);
};

export const setVirtualCareEligibilities = (
  enableVirtualCareEpic: boolean,
  planToken: string,
  members: any,
  isVirtualCareUnetRailroadSuppressed: boolean,
  isVirtualCareSuppressedForEmpire: boolean = false,
  setEligibilities: (planToken: string, eligibilities: any[]) => void
) => {
  if (
    isVirtualCareSuppressed(members?.population) ||
    isVirtualCareUnetRailroadSuppressed ||
    isVirtualCareSuppressedForEmpire
  ) {
    setEligibilities(planToken, []);
    return;
  }
  if (enableVirtualCareEpic && planToken && members?.data) {
    const memberInfo = members?.data?.memberInfo[0];

    const eligibilities =
      filterVirtualCareEligibilitiesForDVCN(memberInfo) ?? [];

    setEligibilities(planToken, eligibilities);
  }
};
